import { Icon, type IconName } from './Icon';

export interface SegmentOption<T extends string> {
  value: T;
  label: string;
  icon?: IconName;
  disabled?: boolean;
  title?: string;
}

/**
 * A segmented control: one of a few mutually exclusive options, shown as a raised pill on a track
 * (radio inputs underneath, so it is keyboard- and screen-reader-friendly). Sized to its content —
 * it never stretches to look like a text field.
 */
export function Segmented<T extends string>({ name, value, options, onChange, label, size = 'md' }: { name: string; value: T; options: SegmentOption<T>[]; onChange: (v: T) => void; label?: string; size?: 'sm' | 'md' }) {
  return (
    <span class={`segmented ${size === 'sm' ? 'segmented-sm' : ''}`} role="radiogroup" aria-label={label}>
      {options.map((o) => (
        <label key={o.value} class={`seg ${o.value === value ? 'on' : ''} ${o.disabled ? 'off' : ''}`} title={o.title}>
          <input type="radio" name={name} value={o.value} checked={o.value === value} disabled={o.disabled} onChange={() => onChange(o.value)} />
          {o.icon && <Icon name={o.icon} size={14} />}
          {o.label}
        </label>
      ))}
    </span>
  );
}
